import { render, staticRenderFns } from "./ActionAnswerStats.vue?vue&type=template&id=66bf57cf&"
import script from "./ActionAnswerStats.vue?vue&type=script&lang=ts&"
export * from "./ActionAnswerStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports